module.exports = __webpack_public_path__ + "static/media/elephants-4275741_1280.eb2b45c1.jpg";